const runInMicrotask = (readOrWrite) => Promise.resolve().then(readOrWrite);
const collectStoredKeys = () => {
    const storedKeys = [];
    for (let keyIndex = 0; keyIndex < localStorage.length; keyIndex += 1) {
        const storedKey = localStorage.key(keyIndex);
        if (storedKey !== null) {
            storedKeys.push(storedKey);
        }
    }
    return storedKeys;
};
const platformStorageWeb = {
    adapterName: "web",
    getItem(key) {
        return runInMicrotask(() => localStorage.getItem(key));
    },
    setItem(key, value) {
        return runInMicrotask(() => {
            localStorage.setItem(key, value);
        });
    },
    removeItem(key) {
        return runInMicrotask(() => {
            localStorage.removeItem(key);
        });
    },
    clear() {
        return runInMicrotask(() => {
            localStorage.clear();
        });
    },
    getAllKeys() {
        return runInMicrotask(collectStoredKeys);
    },
};
export default platformStorageWeb;
